module.exports = {"130407100":"肥乡镇","130407101":"天台山镇","130407102":"辛安镇镇","130407103":"大寺上镇","130407104":"东漳堡镇","130407202":"毛演堡乡","130407203":"元固乡","130407204":"屯庄营乡","130407206":"旧店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130407.json
// module id = 113
// module chunks = 0